import Channel from "./ChannelInfo";
import ChannelDescription from "./ChannelDescription";
import ChannelName from "./ChannelName";
import ChannelSubmit from "./ChannelSubmit";
import ChannelProfileImage from "./ChannelProfileImage";
import ChannelBannerMessage from "./ChannelBannerMessage";

export default Object.assign(Channel, {
  Name: ChannelName,
  Description: ChannelDescription,
  BannerMessage: ChannelBannerMessage,
  Submit: ChannelSubmit,
  ProfileImage: ChannelProfileImage,
});
